import { Card, CardHeader } from '@/components'
import { ExistingUserFooter } from '../components/ExistingUserFooter'
import { LegalFooter } from '../components/LegalFooter'
import { OtpForm } from '../components/OtpForm'
import { TrialPageFrame } from '../components/TrialPageFrame'
import { TrialPitch } from '../components/TrialPitch'
import { TrialSignUpForm } from '../components/TrialSignUpForm'
import { type TrialSignUp, useTrialSignUp } from '../hooks/useTrialSignUp'

export const TrialSignUpPage = () => {
  const trial = useTrialSignUp()

  return (
    <TrialPageFrame>
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1fr)_440px] lg:items-start lg:gap-16">
        <TrialPitch />
        <Card className="lg:sticky lg:top-8">
          {trial.isEnteringCode ? (
            <OtpForm
              email={trial.form.data.email as string}
              onCodeVerified={trial.finishSignUp}
              onReturn={trial.editDetails}
              onResend={trial.sendCode}
            />
          ) : (
            <TrialDetails trial={trial} />
          )}
        </Card>
      </div>
      <LegalFooter />
    </TrialPageFrame>
  )
}

const TrialDetails = ({ trial }: { trial: TrialSignUp }) => (
  <>
    <CardHeader className="pb-4">
      <h2 className="text-center text-xl font-semibold tracking-tight">
        {trial.prefilledFirstName
          ? `Welcome, ${trial.prefilledFirstName}`
          : 'Start your free trial'}
      </h2>
    </CardHeader>
    <TrialSignUpForm trial={trial} />
    <ExistingUserFooter />
  </>
)
